export enum brandName {
    telioev = 'telioev',
    nuvostella = 'nvstl',
    electicx = 'elecx'
}
